import LOGO from "../images/Grizzlies.png";

export const Team__Grizzlies = {
  name: "Grizzlies",
  logoImage: LOGO,
  teamImage: null,
  teamLogoColor: "#111111",
  teamJerseyColor: "#222222",

  // Stats
  gamesWon: 0,
  gamesLost: 3,
  gamesTied: 0,
  gamesTiedWon: 0,

  ownGoalsInFavor: 41 + 16 + 21,
  goalsScoredAgainst: 43 + 18 + 58,
  defaultGoals: 0,

  isChampion: false,
  isEliminated: false,

  players: [],
};
